/* Advertorial shopping behaviour: tab switching, variant price sync, and
   async add to cart.

   Cart handling is delegated from the document rather than bound inside the
   tab element, because product cards appear in two places — the tabbed grid
   at the end and the strip early in the story — and only the grid is wrapped
   in <lp-tabs>. Delegation covers both, and any card added later.

   Everything here is an enhancement; the markup is a real form and works
   without it. */

class LpTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.select(i));
      tab.addEventListener('keydown', (e) => this.onKeydown(e, i));
    });
  }

  select(index) {
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      this.panels[i].hidden = !active;
    });
  }

  onKeydown(event, index) {
    const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
    if (!step) return;
    event.preventDefault();
    const next = (index + step + this.tabs.length) % this.tabs.length;
    this.select(next);
    this.tabs[next].focus();
  }
}

if (!customElements.get('lp-tabs')) {
  customElements.define('lp-tabs', LpTabs);
}

/* --- cart, delegated ----------------------------------------------------- */

const LpCart = {
  /* Keep the displayed price honest when the shopper picks another variant. */
  syncPrice(select) {
    const option = select.options[select.selectedIndex];
    const body = select.closest('.lp__card-body');
    const target = body && body.querySelector('[data-lp-price]');
    if (!option || !target) return;

    const compare = option.dataset.compare;
    target.innerHTML = compare
      ? `<span class="lp__price-sale">${option.dataset.price}</span> <s class="lp__price-was">${compare}</s>`
      : option.dataset.price;
  },

  async add(form) {
    const button = form.querySelector('[name="add"]');
    const label = form.querySelector('[data-lp-add-text]');
    const original = label ? label.textContent : '';
    if (button) button.disabled = true;
    if (label) label.textContent = 'Adding…';

    try {
      const id = Number(new FormData(form).get('id'));
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
      });

      if (!response.ok) throw new Error('add failed');

      if (label) label.textContent = 'Added ✓';
      LpCart.refresh();
      setTimeout(() => {
        if (label) label.textContent = original;
        if (button) button.disabled = false;
      }, 1600);
    } catch (error) {
      // Last resort: a normal post, so the shopper is never stuck.
      form.submit();
    }
  },

  /* Nudge Dawn's cart drawer and bubble to re-read the cart. */
  refresh() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;

    fetch(`${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`)
      .then((r) => r.json())
      .then((sections) =>
        drawer.renderContents({ sections, sections_url: window.location.pathname })
      )
      .catch(() => {});
  },
};

document.addEventListener('submit', (event) => {
  const form = event.target.closest('[data-lp-form]');
  if (!form || !window.fetch) return;
  event.preventDefault();
  LpCart.add(form);
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-lp-variants]');
  if (select) LpCart.syncPrice(select);
});
